const sendRequestExtension = {
    namespaced: true,
    state: {
        visible: false,
        resolve: null,
        reject: null,

        subject: null,
        requestedControlDate: null,
        minDate: null,
        attachments: []
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_SUBJECT(state, payload) {
            state.subject = payload;
        },
        SET_DATE(state, payload){
            state.requestedControlDate = payload;
        },
        SET_MINDATE(state, payload){
            state.minDate = payload;
        },
        SET_ATTACHMENTS(state, payload){
            state.attachments = payload;
        },
        PUSH_ATTACHMENT(state, payload) {
            state.attachments.push(payload);
        },
        DEL_ATTACHMENT(state, payload) {
            if (Number.isInteger(Number(payload)) && state.attachments.length > Number(payload))
            state.attachments.splice(payload);
        }
    },
    actions: {
        async open({ commit, rootGetters }) {
            commit('SET_SUBJECT', null);
            commit('SET_DATE', null);
            const controlDateEpoch = rootGetters['global/actionsource/getControlDate'];
            const toDay = this._vm.$moment();
            let controlDate = null;
            if (controlDateEpoch)
                controlDate = this._vm.$moment(controlDateEpoch);
            if (!!controlDate && controlDate.isAfter(toDay))
                commit('SET_MINDATE', controlDate.format('YYYY-MM-DD'));
            else 
                commit('SET_MINDATE', toDay.format('YYYY-MM-DD')); 
             
            commit('SET_ATTACHMENTS', []);
            commit('SET_VISIBLE', true);
            
            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);

            let result =  {
                subject : state.subject,
                requestedControlDate: state.requestedControlDate,
                attachments: state.attachments
            };
            
            state.resolve(result);
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        getSubject: (s) => s.subject,
        getDate:(s) => s.requestedControlDate,
        getMinDate: (s) => s.minDate,
        getAttachments: (s) => s.attachments,
    }
}

export default sendRequestExtension;